import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationMarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 3H17L22 12L17 21H7L2 12L7 3ZM12 6.3C12.386 6.3 12.7 6.614 12.7 7V13C12.7 13.386 12.386 13.7 12 13.7C11.614 13.7 11.3 13.386 11.3 13V7C11.3 6.614 11.614 6.3 12 6.3ZM12 16C11.448 16 11 16.448 11 17C11 17.552 11.448 18 12 18C12.552 18 13 17.552 13 17C13 16.448 12.552 16 12 16Z",
		fill: "currentColor"
	})
});
export default SvgExclamationMarkFill;
